import {
  Directive,
  ElementRef,
  inject,
  OnInit,
  Renderer2,
} from '@angular/core';
import {
  getDataAttributeForEventType,
  ThasEventType,
} from '@thiememeulenhoff/analytics-service-client';

@Directive()
export abstract class AttributeDirective implements OnInit {
  protected abstract readonly type: ThasEventType;
  public abstract value?: string;

  #renderer = inject(Renderer2);
  #element = inject(ElementRef).nativeElement as HTMLElement;

  public ngOnInit(): void {
    this.#setDataAttribute(this.value);
  }

  #setDataAttribute(value?: string) {
    this.#renderer.setAttribute(
      this.#element,
      getDataAttributeForEventType(this.type),
      value || ''
    );
  }
}
